<p-dialog
  header="Hide Route"
  [modal]="true"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '600px' }"
  (onShow)="onShow()"
>
  <div class="mb-3">Enter the reason for hiding this route</div>

  <div *ngFor="let reason of reasons" class="rejection-item">
    <input
      type="radio"
      id="radio-{{ reason.id }}"
      value="{{ reason.id }}"
      [(ngModel)]="hiddenReason"
      name="reason"
      class="rejection-item-radio"
    />
    <label for="radio-{{ reason.id }}">{{ reason.description }}</label>
  </div>

  <div class="text-input">
    <textarea
      class="text-area"
      [(ngModel)]="reasonText"
      *ngIf="needsTextInput(this.hiddenReason)"
      placeholder="Please specify reason"
    ></textarea>
  </div>

  <div class="flex mt-3 grid-gap-15">
    <div class="flex-grow-1">
      <button
        type="button"
        pButton
        label="Cancel"
        icon="fa fa-times"
        class="block w-full"
        (click)="visibleChange.emit(false)"
      ></button>
    </div>
    <div class="flex-grow-1">
      <button
        type="button"
        pButton
        label="Hide Route"
        icon="fa fa-trash"
        (click)="onHideRouteClick()"
        [disabled]="!canSubmitReason()"
        class="ui-button-danger block w-full"
      ></button>
    </div>
  </div>
</p-dialog>
